module.exports = __webpack_public_path__ + "media/images/mailers/email_logo_header-55aedcd15c1406ec685896d274e475f7.png";